import { render, staticRenderFns } from "./visitas_pendientes.vue?vue&type=template&id=78f4adf7&scoped=true"
import script from "./visitas_pendientes.vue?vue&type=script&lang=js"
export * from "./visitas_pendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4adf7",
  null
  
)

export default component.exports